import { Grid, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TIPOS_MENSAJES } from "../../Constants";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { axiosClient } from "../AxiosClient";

const ImageBubble = styled("div")(({ sent }) => ({
  backgroundColor: sent ? "#dcf8c6" : "#fff",
  padding: "4px",
  borderRadius: "7.5px",
  maxWidth: "330px",
  position: "relative",
  boxShadow: "0 1px 0.5px rgba(0,0,0,0.13)",
  marginBottom: "10px",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    width: 0,
    height: 0,
    border: "10px solid transparent",
    ...(sent
      ? {
          right: "-10px",
          borderLeftColor: "#dcf8c6",
          borderRight: 0,
          borderTop: 0,
        }
      : {
          left: "-10px",
          borderRightColor: "#fff",
          borderLeft: 0,
          borderTop: 0,
        }),
  },
}));

const ImageContainer = styled("div")({
  position: "relative",
  cursor: "pointer",
  "&:hover": {
    opacity: 0.9,
  },
});

const StyledImage = styled("img")({
  width: "100%",
  maxHeight: "330px",
  objectFit: "cover",
  borderRadius: "4px",
});

const MessageMeta = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  position: "absolute",
  bottom: "8px",
  right: "8px",
  backgroundColor: "rgba(0,0,0,0.3)",
  padding: "2px 6px",
  borderRadius: "12px",
});

const MessageTime = styled("span")({
  fontSize: "11px",
  color: "#fff",
});

const MessageTick = styled(DoneAllIcon)({
  fontSize: "16px",
  color: "#fff",
});

export default function Image({
  imageKey,
  tipos,
  times,
  onClick,
  fetchMediaUrl,
}) {
  const [image, setImage] = useState();
  const isSent = tipos === TIPOS_MENSAJES.enviado;

  useEffect(() => {
    if (imageKey) {
      setImage(imageKey);
    }
  }, [imageKey, fetchMediaUrl]);

  return (
    <Grid
      container
      justifyContent={isSent ? "flex-end" : "flex-start"}
      sx={{ padding: "0 5%" }}
    >
      <ImageBubble sent={isSent}>
        <ImageContainer>
          <StyledImage
            src={image}
            alt="Mensaje de WhatsApp"
            onClick={onClick}
            style={{ cursor: "pointer" }}
          />
          <MessageMeta>
            <MessageTime>{times}</MessageTime>
            {isSent && <MessageTick />}
          </MessageMeta>
        </ImageContainer>
      </ImageBubble>
    </Grid>
  );
}
